import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {ApiService, HttpError} from '../../shared/api.service';
import {NavigationService} from '../../shared/navigation.service';
import {PasswordsService} from '../../shared/passwords.service';

@Component({
  selector: 'account-reset-page',
  templateUrl: './account-reset-page.component.html',
  styleUrls: ['./account-reset-page.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountResetPageComponent implements OnInit {

  resetForm: FormGroup;
  code: string;

  submitted = false;
  submitting = false;
  submitError: string | null = null;
  submitErrorCode: string | null = null;

  constructor(private FormBuilder: FormBuilder,
              private Api: ApiService,
              private route: ActivatedRoute,
              private Navigation: NavigationService,
              private Passwords: PasswordsService) {
  }

  ngOnInit() {
    this.code = this.route.snapshot.queryParamMap.get('code');
    if (!this.code) {
      this.Navigation.handleNotFound();
    }
    this.resetForm = this.FormBuilder.group({
      password: ['', [Validators.required, (control: AbstractControl): ValidationErrors | null => {
        return this.Passwords.measureStrength(control.value) < this.Passwords.getMaxStrength() ? {strength: true} : null;
      }]],
      passwordConfirm: ['']
    }, {
      validator: (): ValidationErrors | null => {
        return !this.resetForm || this.password.value !== this.passwordConfirm.value ? {confirm: true} : null;
      }
    });
  }

  submit() {
    this.submitted = true;
    this.submitError = null;
    this.submitErrorCode = null;

    if (this.resetForm.valid) {
      this.submitting = true;
      this.Api.resetPassword(this.code, this.password.value)
        .subscribe(() => {
          this.Navigation.handleLogin(false, {reset: true});
        }, (err: HttpError) => {
          this.submitting = false;
          this.submitError = 'server-error';
          this.submitErrorCode = err && err.code;
        });
    }
  }

  get password() {
    return this.resetForm.get('password');
  }

  get passwordConfirm() {
    return this.resetForm.get('passwordConfirm');
  }
}
